import type { FaireProductEntity } from "../../entity_types/product";

export const p_mpbbq4j9nd: FaireProductEntity = {
  token: "p_mpbbq4j9nd",
  type: "product",
  name: "Midnight in Honolulu Tea Towel",
  brandName: "RHB HAWAII",
  imageUrl:
    "https://cdn.faire.com/fastly/467ec901acb730c35677e84488c9c06748f77141a0f8de20314ccbf8226fe79d.jpeg",
  priceDollars: 8.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/26bd1bd8a2ba7244a1bdf90c49a52b22f19d8e307d7aec153ef7883f49001e50.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
